import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Accordion, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Loader from 'react-loader-spinner'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { utilHelper } from '../../helpers';
import { alertActions } from '../../modules/alert';
import { dashboardService, opbcdtService } from '../../services';

import PropertiesDialog from '../OpbState/PropertiesDialog';

class OpbStats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSiteID: "",

            siteName: "",
            siteNum: "",
            serviceCnt: 0,
            expireCnt: 0,
            stopCnt: 0,
            connectY: 0,
            connectN: 0,
            opbNoList: [],

            playLogList: [],
            selectedOpbInfo: "",
            mode: "",
            loading: false,
        };
    }

    componentDidUpdate(prevProps) {
        const { selectedSiteID } = this.props;
        if (prevProps.selectedSiteID !== "" && selectedSiteID === "") {
            this.stateRefresh();
        }
        else if (selectedSiteID !== 0 && prevProps.selectedSiteID !== selectedSiteID) {
            this.setOpbStats();
        }
    }

    stateRefresh = () => {
        this.setState({
            selectedSiteID: "",

            siteName: "",
            siteNum: "",
            serviceCnt: 0,
            expireCnt: 0,
            stopCnt: 0,
            connectY: 0,
            connectN: 0,
            opbNoList: [],

            playLogList: [],
            selectedOpbInfo: "",
            mode: "",
            loading: false,
        });
    };

    setOpbStats = () => {
        const { selectedSiteID } = this.props;

        this.setState({
            loading: true
        });

        let formData = new FormData();
        formData.append("siteID", selectedSiteID);
        dashboardService.opbStats(formData)
            .then(response => {
                this.setState({
                    ...response.data,
                    selectedSiteID: selectedSiteID,
                    loading: false,
                });
            })
            .catch(this.handleErrors)
    };

    handleSelectedOpb = (opbID, mode) => {
        // Display 호기 선택
        // mode = template     템플릿설정
        // mode = floors       층 설정
        // mode = content      홍보영상, 마케팅영상, 하단영상설정
        // mode = opb          현장정보, 수정이력, 원격화면 캡쳐 
        let formData = new FormData();
        formData.append("siteID", this.state.siteID);
        formData.append("opbID", opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                this.setState({
                    selectedOpbInfo: response.data,
                    mode: mode
                });
            })
            .catch(this.handleErrors)
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    errorAlerts = (text) => {
        this.props.errorAlerts(text);
    };

    selectedOpbInfoRefresh = () => {
        // 선택한 OPB를 해제한다.
        this.setState({
            selectedOpbInfo: '',
            loading: false,
        });
    };


    render() {
        const { siteID, siteName, siteNum, serviceCnt, expireCnt, stopCnt, connectY, connectN, opbNoList, playLogList, loading, selectedOpbInfo, mode } = this.state;

        return (
            <div className="dashboard-opbstats">
                <div className="dashboard-opbstats-title">
                    {siteName &&
                        <>
                            <div className="col col-9 text-align-center">{siteName} ({siteNum})</div>
                            <div className="col col-3">
                                <Link to={{ pathname: "/opbstate", state: { siteID: siteID } }}>
                                    <button className="button white-all-button transparent-button w27-button" style={{ opacity: 0.5 }}>바로가기</button>
                                </Link>
                            </div>
                        </>
                    }
                </div>
                <div className="dashboard-opbstats-contents">
                    {loading
                        ?
                        <>
                            <div className="text-align-center">
                                <Loader
                                    type="Rings"
                                    color="#00BFFF"
                                    height={'50%'}
                                    width={'50%'}
                                />
                            </div>
                        </>
                        :
                        <>
                            <div className="dashboard-opbstats-item">
                                <div className="title">
                                    <img className="ic-refresh" src="/assets/images/dashboard/ic_contract.svg" alt="계약상태" />계약상태
                                </div>
                                <div className="row text-align-center">
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>정상 계약상태를 가짐</Tooltip>}>
                                        <div className="col">정상 <span>{serviceCnt}</span></div>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>운영자에 의해 중단됨</Tooltip>}>
                                        <div className="col">중단 <span>{stopCnt}</span></div>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>계약기간이 초과됨</Tooltip>}>
                                        <div className="col">만료 <span>{expireCnt}</span></div>
                                    </OverlayTrigger>
                                </div>
                            </div>

                            <div className="dashboard-opbstats-item">
                                <div className="title">
                                    <img className="ic-refresh" src="/assets/images/dashboard/ic_connection.svg" alt="연결상태" />연결상태
                                </div>
                                <div className="row text-align-center">
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>정상 계약중 연결됨</Tooltip>}>
                                        <div className="col">연결 <span>{connectY}</span></div>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>정상 계약중 연결이 끊김</Tooltip>}>
                                        <div className="col">끊김 <span>{connectN}</span></div>
                                    </OverlayTrigger>
                                    <div className="col"></div>
                                </div>
                            </div>

                            <div className="dashboard-opbstats-item">
                                <Accordion>
                                    {opbNoList && opbNoList.length > 0 &&
                                        opbNoList.map((opbNo, i) =>
                                            <OpbNoItem key={i} opbNo={opbNo} handleSelectedOpb={this.handleSelectedOpb} errorAlerts={this.errorAlerts} />)
                                    }
                                </Accordion>
                            </div>

                            <div className=""><hr /></div>

                            <div className="dashboard-opbstats-item">
                                <div className="" style={{ fontSize: 16, color: "#4a73e9" }}>
                                    <img className="ic-refresh" src="/assets/images/dashboard/is_play.svg" alt="플레이타임" />플레이타임
                                </div>
                                <div className="">
                                    <table className="w100per">
                                        <colgroup>
                                            <col width="60%" />
                                            <col width="20%" />
                                            <col width="20%" />
                                        </colgroup>
                                        <thead className="table-head">
                                            <tr>
                                                <th className="table-head-cell">제목</th>
                                                <th className="table-head-cell">유형</th>
                                                <th className="table-head-cell">재생시간</th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            {playLogList && playLogList.length > 0
                                                ?
                                                playLogList.map((contents, i) =>
                                                    <tr className="contents-item" key={i}>
                                                        <td className="text-align-center">{contents.title}</td>
                                                        <td className="text-align-center">{contents.uniqFileName.slice(-3) === "mp4" ? "영상" : "이미지"}</td>
                                                        <td className="text-align-center">{contents.playTime}</td>
                                                    </tr>
                                                )
                                                :
                                                <tr>
                                                    <td className="text-align-center" colSpan={3}>
                                                        <div className="" style={{ margin: '20px auto' }}>
                                                            <img src={"/assets/images/ic-no-data.svg"} alt="데이터없음" /><br />데이터가 없습니다.
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            {selectedOpbInfo &&
                                <PropertiesDialog opbInfo={selectedOpbInfo} mode={mode} selectedOpbInfoRefresh={this.selectedOpbInfoRefresh} />
                            }
                        </>
                    }
                </div>
            </div>
        );
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(OpbStats);



class OpbNoItem extends Component {

    handleSelectedOpb = (opbID, mode) => {
        this.props.handleSelectedOpb(opbID, mode);
    };

    errorAlerts = (text) => {
        this.props.errorAlerts(text);
    };

    render() {
        const { opbName, opbNo, totalCnt, opbInfoList } = this.props.opbNo;

        return (
            <Card style={{ marginBottom: "10px" }}>
                <Accordion.Toggle eventKey={opbNo} style={{ border: "none" }}>
                    <div className="row dashboard-opbstats-opbnoitem" style={{ height: "50px", color: "white", background: "#4052fe", alignItems: "center" }}>
                        <div className="col col-7 text-align-left" style={{ paddingLeft: "20px" }}>{opbName}</div>
                        <div className="col col-3">총 {totalCnt}대</div>
                        <div className="col col-2"><img className="ic-refresh" src="/assets/images/dashboard/btn_down.svg" alt="아래확장" /></div>
                    </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={opbNo}>
                    <Card.Body style={{ color: "#ffffff", background: "#3d81ff" }}>
                        {opbInfoList && opbInfoList.length > 0 &&
                            opbInfoList.map((opbinfo, i) => <OpbInfoItem key={i} opbinfo={opbinfo} handleSelectedOpb={this.handleSelectedOpb} errorAlerts={this.errorAlerts} />)
                        }
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        );
    }
}

class OpbInfoItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            anchorEl: ""
        }
    }

    handleSelectedOpb = (mode) => {
        // (mode === "template") 템플릿설정 팝업으로 이동
        // (mode === "floors") 층설정 팝업으로 이동
        // (mode === "content") 컨텐츠설정 팝업으로 이동
        // (mode === "opb") 기본정보 팝업으로 이동
        const { opbID, opbStatus, connectYN } = this.props.opbinfo;

        if (opbStatus !== "" && connectYN === 'Y') this.props.handleSelectedOpb(opbID, mode);
        else this.props.errorAlerts("Display 연결이 끊겼습니다. 확인 후 이용해주세요.");
    };

    handleMenuOpen = (e) => {
        this.setState({
            open: true,
            anchorEl: e.target
        });
    };
    handleMenuClose = () => {
        this.setState({
            open: false,
            anchorEl: null
        });
    };


    render() {
        const { anchorEl, open } = this.state;
        const { opbStatus, slotCode, connectYN } = this.props.opbinfo;

        let className = "";
        if (opbStatus === "ST001" && connectYN === "N") className = "connect_n";
        else if (opbStatus === "ST001") className = "normal";
        else if (opbStatus === "ST002") className = "stop";
        else if (opbStatus === "ST003") className = "expired";

        return (
            <>
                <div className="row dashboard-opbstats-opbinfoitem" >
                    <div className="col col-7" >
                        <div className={`status-dot-color ${className}`} style={{ display: "inline-flex" }}></div>
                        &nbsp;&nbsp;{utilHelper.getCodeName(slotCode)}
                    </div>
                    <div className="col col-3" >{utilHelper.getCodeName(opbStatus)}</div>
                    <div className="col col-2" >
                        {className === "normal"
                            ? <button className="button white-all-button transparent-button w27-button" style={{ opacity: 0.7 }} onClick={this.handleMenuOpen}>설정</button>
                            : <button className="button white-all-button transparent-button w27-button" style={{ opacity: 0.7 }} disabled >
                                {className === "connect_n" ? "끊김" : className === "stop" ? "중단" : "만료"}
                            </button>
                        }
                    </div>
                </div>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem onClick={() => { this.handleSelectedOpb("template"); this.handleMenuClose(); }}>템플릿설정</MenuItem> {/* 템플릿설정 */}
                    <MenuItem onClick={() => { this.handleSelectedOpb("floors"); this.handleMenuClose(); }}>층 설정</MenuItem> {/* 층 설정 */}
                    <MenuItem onClick={() => { this.handleSelectedOpb("content"); this.handleMenuClose(); }}>컨텐츠설정</MenuItem> {/* 홍보영상, 마케팅영상, 하단영상설정 */}
                    <MenuItem onClick={() => { this.handleSelectedOpb("opb"); this.handleMenuClose(); }}>현장정보</MenuItem> {/* 현장정보, 수정이력, 원격화면 캡쳐 */}
                </Menu>
            </>
        );
    }
}
